import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';
import { WorkItem } from '../models/work-item';
import { WorkItemChooserComponent } from '../work-item-chooser/work-item-chooser.component';
import { WorkItemEditComponent } from '../work-item-edit/work-item-edit.component';
import { AiService } from '../services/ai.service';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-work-item-list',
  templateUrl: './work-item-list.component.html',
  styleUrls: ['./work-item-list.component.scss'],
})
export class WorkItemListComponent {
  @Input() workItems: WorkItem[] = [];
  @Input() currencyCode: string;
  @Input() businessId: number;
  @Input() loadingFromAI = false;
  @Output() workItemsChange = new EventEmitter<WorkItem[]>();
  @Output() loadingFromAIChange = new EventEmitter<boolean>(); // Emit changes to loadingFromAI

  isReorderMode = false;

  constructor(
    private modalCtrl: ModalController,
    private alertController: AlertController,
    private aiService: AiService,
    private apiService: ApiService
  ) {}

  async addWorkItem() {
    const modal = await this.modalCtrl.create({
      component: WorkItemChooserComponent,
      canDismiss: true,
      componentProps: { currencyCode: this.currencyCode },
    });

    modal.onDidDismiss().then((data) => {
      if (data.data && data.data.length > 0) {
        const newItems = data.data.map((item) => new WorkItem().deserialize(item));
        this.workItems.push(...newItems);
        this.workItemsChange.emit(this.workItems);
      }
    });

    await modal.present();
  }

  async editWorkItem(index: number) {
    const modal = await this.modalCtrl.create({
      component: WorkItemEditComponent,
      canDismiss: true,
      componentProps: {
        workItemToUpdate: this.workItems[index],
        currencyCode: this.currencyCode,
      },
    });

    modal.onDidDismiss().then((data) => {
      if (data.data) {
        this.workItems[index] = new WorkItem().deserialize(data.data);
        this.workItemsChange.emit(this.workItems);
      }
    });

    await modal.present();
  }

  removeWorkItem(index: number) {
    this.workItems.splice(index, 1);
    this.workItemsChange.emit(this.workItems);
  }

  async generateWorkItems() {
    if (!this.businessId) {
      const alert = await this.alertController.create({
        header: 'Please choose a business',
        message: 'You need to choose a business before you can generate Work Items',
        buttons: ['OK'],
      });
      await alert.present();
      return;
    }

    this.loadingFromAI = true;
    this.loadingFromAIChange.emit(this.loadingFromAI); // Emit the updated value

    try {
      const newItems = await this.aiService.jobDescriptionPrompt(this.businessId);
      this.workItems.push(...newItems);
      this.workItemsChange.emit(this.workItems);
    } catch (error) {
      console.error('Error generating work items:', error);
    } finally {
      this.loadingFromAI = false;
      this.loadingFromAIChange.emit(this.loadingFromAI); // Emit the updated value
    }
  }

}